import { render, staticRenderFns } from "./AgendorIcon.vue?vue&type=template&id=f3142b98&"
import script from "./AgendorIcon.vue?vue&type=script&lang=ts&"
export * from "./AgendorIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports